import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock3Icon } from 'lucide-react';
const STORAGE_KEY = 'salsa_bachata_instructor_ready_countdown';
function getInitialTarget(): number {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  const parsed = stored ? Number.parseInt(stored, 10) : 0;
  if (parsed > Date.now()) return parsed;
  const target = Date.now() + 24 * 60 * 60 * 1000;
  window.localStorage.setItem(STORAGE_KEY, String(target));
  return target;
}
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(24 * 60 * 60 * 1000);
  useEffect(() => {
    let target = getInitialTarget();
    const tick = () => {
      if (target <= Date.now()) target = getInitialTarget();
      setRemaining(Math.max(0, target - Date.now()));
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className="mx-auto mt-12 max-w-3xl rounded-xl border border-gold/40 bg-cream p-6 text-center shadow-soft sm:p-8" data-id="element-49" data-mp="1gxouopqyekgs">
      <div className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-burgundy" data-id="element-50" data-mp="1zq9ivtvpk1e9">
        <Clock3Icon size={18} className="text-gold" aria-hidden="true" data-id="element-51" data-mp="1l1wj0lti1yeh" /> The
        $26.90 USD offer ends in
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 sm:gap-4" data-id="element-52" data-mp="1pz5690ti8sml">
        <TimeBox value={pad(hours)} label="h" data-id="element-53" data-mp="2dpsfpqj2jqb9" />
        <span className="font-display text-2xl text-gold" data-id="element-54" data-mp="2dopmhby9xbs6">:</span>
        <TimeBox value={pad(minutes)} label="min" data-id="element-55" data-mp="2ihsjxv6695dn" />
        <span className="font-display text-2xl text-gold" data-id="element-56" data-mp="2iilhq6n5kkjn">:</span>
        <TimeBox value={pad(seconds)} label="s" data-id="element-57" data-mp="2sc7o21gjhqad" />
      </div>
      <p className="mt-6 text-sm font-semibold text-ink" data-id="element-58" data-mp="2nd4ogwjbwc9s">
        Get the complete system and all 5 bonuses at the current price.
      </p>
      <div className="mt-6 text-left" data-id="element-59" data-mp="2jahxsyye8xe6">
        <div className="mb-2 flex justify-between gap-4 text-xs font-medium text-ink-muted" data-id="element-60" data-mp="2ed89jmmqqrrx">
          <span data-id="element-61" data-mp="29dvck925o4bm">Current price access</span>
          <span className="font-semibold text-burgundy" data-id="element-62" data-mp="29eww71x8lz4y">
            Only a few spots left
          </span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-beige" data-id="element-63" data-mp="24lu30uwdgrpa">
          <div className="h-full w-[65%] rounded-full bg-wine" data-id="element-64" data-mp="1zp3o4awb025g" />
        </div>
        <p className="mt-2 text-right text-xs text-ink-muted" data-id="element-65" data-mp="1vn0b3htzkpi2">
          65% of spots already taken
        </p>
      </div>
    </motion.div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="min-w-[74px] rounded-lg border border-gold/50 bg-ink px-3 py-3 sm:min-w-[100px]" data-id="element-66" data-mp="1lpc67z2o21m6">
      <span className="font-display text-3xl font-semibold tabular-nums text-cream sm:text-4xl" data-id="element-67" data-mp="15gp06vneahv">
        {value}
      </span>
      <span className="ml-1 text-xs font-semibold text-champagne" data-id="element-68" data-mp="63ibl1sa8ry3">
        {label}
      </span>
    </div>;
}